export const dailyChallengesAssetConfig = <const>{
  monday: {
    title_en: {
      image: 'assets/ui/match2/daily_challenges/monday/title_monday_en.png',
      width: 458,
      height: 124,
    },
    title_jp: {
      image: 'assets/ui/match2/daily_challenges/monday/title_monday_jp.png',
      width: 456,
      height: 116,
    },
    splash: {
      image: 'assets/ui/match2/daily_challenges/monday/splash_monday.png',
      width: 397,
      height: 353,
    },
  },
  tuesday: {
    title_en: {
      image: 'assets/ui/match2/daily_challenges/tuesday/title_tuesday_en.png',
      width: 372,
      height: 141,
    },
    title_jp: {
      image: 'assets/ui/match2/daily_challenges/tuesday/title_tuesday_jp.png',
      width: 456,
      height: 105,
    },
    splash: {
      image: 'assets/ui/match2/daily_challenges/tuesday/splash_tuesday.png',
      width: 422,
      height: 325,
    },
  },
  wednesday: {
    title_en: {
      image:
        'assets/ui/match2/daily_challenges/wednesday/title_wednesday_en.png',
      width: 450,
      height: 155,
    },
    title_jp: {
      image:
        'assets/ui/match2/daily_challenges/wednesday/title_wednesday_jp.png',
      width: 450,
      height: 97,
    },
    splash: {
      image: 'assets/ui/match2/daily_challenges/wednesday/splash_wednesday.png',
      width: 397,
      height: 325,
    },
  },
  thursday: {
    title_en: {
      image: 'assets/ui/match2/daily_challenges/thursday/title_thursday_en.png',
      width: 362,
      height: 121,
    },
    title_jp: {
      image: 'assets/ui/match2/daily_challenges/thursday/title_thursday_jp.png',
      width: 362,
      height: 76,
    },
    splash: {
      image: 'assets/ui/match2/daily_challenges/thursday/splash_thursday.png',
      width: 410,
      height: 325,
    },
  },
  friday: {
    title_en: {
      image: 'assets/ui/match2/daily_challenges/friday/title_friday_en.png',
      width: 440,
      height: 77,
    },
    title_jp: {
      image: 'assets/ui/match2/daily_challenges/friday/title_friday_jp.png',
      width: 476,
      height: 89,
    },
    splash: {
      image: 'assets/ui/match2/daily_challenges/friday/splash_friday.png',
      width: 397,
      height: 331,
    },
  },
  saturday: {
    title_en: {
      image: 'assets/ui/match2/daily_challenges/saturday/title_saturday_en.png',
      width: 486,
      height: 113,
    },
    title_jp: {
      image: 'assets/ui/match2/daily_challenges/saturday/title_saturday_jp.png',
      width: 320,
      height: 104,
    },
    splash: {
      image: 'assets/ui/match2/daily_challenges/saturday/splash_saturday.png',
      width: 397,
      height: 373,
    },
  },
  sunday: {
    title_en: {
      image: 'assets/ui/match2/daily_challenges/sunday/title_sunday_en.png',
      width: 410,
      height: 88,
    },
    title_jp: {
      image: 'assets/ui/match2/daily_challenges/sunday/title_sunday_jp.png',
      width: 410,
      height: 109,
    },
    splash: {
      image: 'assets/ui/match2/daily_challenges/sunday/splash_sunday.png',
      width: 422,
      height: 325,
    },
  },
};
